import { type GUID } from '@common/types/brandedTypes';

export const NotificationTypes = {
  Email: 0,
  Sms: 20,
} as const;

export type NotificationType = typeof NotificationTypes[
  keyof typeof NotificationTypes
];

export const NotificationLevelTypes = {
  All: 0,
  Critical: 40,
} as const;

export type NotificationLevelType = typeof NotificationLevelTypes[
  keyof typeof NotificationLevelTypes
];

export interface Subscriber {
  id: number;
  contact: string;
  notificationType: NotificationType;
  notificationLevelType: NotificationLevelType;
  enabled: boolean;
  culture: string;
  canDelete: boolean;
  customerContact: boolean;
  installationContractId?: number | string;
}

export type SubscriberUpdate = Omit<Subscriber, 'canDelete' | 'installationContractId'>;

export type SubscriberCreate = Omit<SubscriberUpdate, 'id'>;

export enum LogEventType {
  RegisterChange = 1,
  FirmwareChange = 2,
  UndeliveredRegisterChange = 3,
  Device = 4,
  Connection = 5,
  AlarmCreated = 6,
  AlarmDeactivated = 7,
  RetailerAccessChanged = 8,
  RetailerAccessRequest = 9,
  ProjectionUpdate = 10,
  BackupOperation = 11,
  UserAccessChanged = 12,
  InstallationAddressChanged = 13,
  PendingDeviceDeletion = 14,
  DataHistoryExportDownload = 15,
}

export interface LogType {
  id: LogEventType;
  name: string;
}

export interface LogAlarmResponse {
  id: number;
  isActive: boolean;
  name: string;
  description: string;
  registerIndex: number;
  code: number;
}

interface LogBackupResponse {
  backupId: GUID;
  backupRestoreId?: GUID;
}

export interface LogItemResponse {
  id: number;
  type: string;
  severity: string;
  timestampUtc: string;
  title: string;
  message: string;
  userId: string;
  user?: {
    id: string;
    firstName: string;
    lastName: string;
  };
  alarm?: LogAlarmResponse;
  backup?: LogBackupResponse;
}

export interface PaginatedLogsResponse {
  logs: LogItemResponse[];
  count: number;
}
